import { Quote } from "lucide-react";
import { testimonials } from "@/data/testimonials";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";

/**
 * TestimonialsSection — otomatis DISEMBUNYIKAN jika belum ada testimoni asli.
 * Tidak ada testimoni palsu. Tambahkan data di src/data/testimonials.js.
 */
export const TestimonialsSection = () => {
  if (!testimonials || testimonials.length === 0) return null;

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="bg-[#F8FAFC] py-20 sm:py-24 lg:py-28"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          kicker="Testimoni"
          title="Apa Kata Klien Kami"
          align="center"
          className="mx-auto"
        />
        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {testimonials.map((t, i) => (
            <Reveal key={t.id} delay={(i % 3) * 0.08}>
              <figure
                data-testid={`testimonial-${t.id}`}
                className="flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-7"
              >
                <Quote className="h-8 w-8 text-[#25D366]" />
                <blockquote className="mt-4 flex-1 text-[15px] leading-relaxed text-slate-700">
                  "{t.quote}"
                </blockquote>
                <figcaption className="mt-6 border-t border-slate-100 pt-4">
                  <div className="font-bold text-slate-900">{t.name}</div>
                  <div className="text-sm text-slate-500">
                    {t.position}
                    {t.company ? `, ${t.company}` : ""}
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
